// extracted by mini-css-extract-plugin
export default {"timer":"styles_timer__+oeg0","timeBtn":"styles_timeBtn__Whyu5","hours":"styles_hours__xOQzY","minutes":"styles_minutes__CTBOh","seconds":"styles_seconds__q6oTA"};